import FromPageIndicator from "../Common/FromPageIndicator";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const TypesOfCancers = () => {
  const [typesOfCancers, setTypesOfCancers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  

  useEffect(() => {

    const fetchCancerType = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://api.dremerz.net/api/DZ_8921_TnpyAmpicon_Cancer_AddCancer_CancerList"
        );
        setTypesOfCancers(response.data);
        console.log(response.data[0]);
        
        setError(null);
      } catch (error) {
        console.error("Error fetching cancer types:", error);
        setError("Failed to load cancer types. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchCancerType();
  }, []);

  const imageBaseUrl = "https://api.dremerz.net/uploads";

  return (
    <>
      <FromPageIndicator />

      <div style={{ backgroundColor: "#FFF4FA", padding: "40px 0" }}>
        <Container>
          <Row className="mb-5 mt-3">
            <Col className="text-center">
              <h2 className="display-5 fw-bold" style={{ color: "#0A8AA0" }}>
                Types of Cancer
              </h2>
              <div
                style={{
                  width: "150px",
                  height: "4px",
                  background: "#0A8AA0",
                  margin: "15px auto",
                }}
              ></div>
            </Col>
          </Row>

          {loading && (
            <div className="text-center py-5">
              <p>Loading cancer types...</p>
            </div>
          )}

          {error && (
            <div className="text-center py-5 text-danger">
              <p>{error}</p>
            </div>
          )}

          <Row className="g-4">
            {typesOfCancers.map((cancer, index) => (
              <Col key={cancer.id} xs={12} sm={6} md={4} className="mb-4">
                <div
                  style={{
                    height: "150px",
                    position: "relative",
                    padding: "20px",
                     backgroundColor: index % 2 === 0 ? "#0A8AA0" : "#fdb813"
                    // backgroundColor: "#0A8AA0"
                    
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <img
                      src={`${imageBaseUrl}/${cancer.image}`}
                      alt={cancer.cancerName}
                      style={{
                        maxHeight: "70px",
                        maxWidth: "70px",
                        marginRight: "15px",
                        filter: "brightness(0) invert(1)"
                      }}
                    />
                    <h3
                      style={{
                        color: "#ffff",
                        fontSize: "24px",
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      {cancer.cancerName}
                    </h3>
                  </div>
                  <div
                    className="bg-light position-absolute"
                    style={{
                      height: "1px",
                      width: "80%",
                      top: "100px",
                      left: "40px",

                    }}
                  ></div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "50px",
                    }}
                  >
                    <Link
                      to={`/cancerdetail/${cancer.id}`}
                      style={{
                        color: "#ffff",
                        textDecoration: "none",
                        fontSize: "16px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "darkblue";
                        e.currentTarget.style.textDecoration = "underline";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "black";
                        e.currentTarget.style.textDecoration = "none";
                      }}
                    >
                      Know More
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="ratio ratio-16x9 mt-5">
            <iframe
              src="https://www.youtube.com/embed/3JhrW6TcyGs"
              title="YouTube video"
              allowFullScreen
            ></iframe>
          </div>
        </Container>
      </div>
    </>
  );
};

export default TypesOfCancers;